import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    TextField,
    Typography,
    Container,
    Paper,
    Stack
} from '@mui/material';
import { AuthProps } from '../types';

const Login: React.FC<AuthProps> = ({ setAuth }) => {
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [code, setCode] = useState<string[]>(['', '', '', '']); // empty by default
    const navigate = useNavigate();

    // SAMPLE MEMBERSHIP CODE (for comparison)
    const SAMPLE_CODE = '1234';

    // Style constants
    const pinkBoxStyle = {
        bgcolor: '#fce4e4',
        color: '#a94442',
        border: '1px solid #ebccd1',
        borderRadius: '8px',
        p: 2,
        width: '100%',
        mb: 3,
        textAlign: 'center'
    };

    const handleCodeChange = (index: number, value: string) => {
        if (value.length <= 1 && /^[0-9]*$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
        }
    };

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();

        const enteredCode = code.join('');

        if (enteredCode.length !== 4) {
            alert('Please enter the 4-digit membership code.');
            return;
        }

        if (enteredCode !== SAMPLE_CODE) {
            alert('Invalid membership code.');
            return;
        }

        if (username === 'admin' && password === 'password') {
            localStorage.setItem('isAdmin', 'true');
            setAuth(true);
            navigate('/admin');
        } else {
            alert('Invalid email or password.');
        }
    };

    return (
        <Container component="main" maxWidth="sm">
            <Paper elevation={0} sx={{ p: 4, mt: 4, border: '1px solid #eee' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#003366', mb: 4 }}>
                    Member Login
                </Typography>

                {/* Top Error Alert */}
                <Box sx={pinkBoxStyle}>
                    <Typography variant="body1">
                        Invalid email or password.
                    </Typography>
                </Box>

                <Box component="form" onSubmit={handleLogin}>
                    <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Email:</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        required
                        sx={{ mb: 3, mt: 0 }}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Password:</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        required
                        type="password"
                        sx={{ mb: 3, mt: 0 }}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    {/* Security Code Section */}
                    <Box sx={{ ...pinkBoxStyle, border: '2px solid #d9534f', mb: 4 }}>
                        <Typography sx={{ color: '#d9534f', fontWeight: 'bold', mb: 2 }}>
                            For security, please enter the Membership Code:
                        </Typography>
                        <Stack direction="row" spacing={2} justifyContent="center">
                            {code.map((digit, idx) => (
                                <TextField
                                    key={idx}
                                    value={digit}
                                    onChange={(e) => handleCodeChange(idx, e.target.value)}
                                    inputProps={{
                                        maxLength: 1,
                                        style: { textAlign: 'center', fontSize: '24px' }
                                    }}
                                    sx={{
                                        width: '70px',
                                        bgcolor: 'white',
                                        '& .MuiOutlinedInput-root': { borderRadius: '4px' }
                                    }}
                                />
                            ))}
                        </Stack>
                    </Box>

                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            bgcolor: '#005fa3',
                            '&:hover': { bgcolor: '#004a80' },
                            textTransform: 'none',
                            fontSize: '18px',
                            px: 4,
                            py: 1,
                            borderRadius: '4px'
                        }}
                    >
                        Login
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default Login;
